var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ui-loader"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"width":"200","src":"/assets/img/loader.gif"}})]):_c('div',{staticClass:"not-fount"},[_vm._v("\n    Записей не найдено!\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }